export default {
  SET_PROFILE_VIEWS: 'setProfileViews',
  SET_SELECTED_PROFILE_VIEW: 'setSelectedProfileView',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_FIELD_CUSTOMER_PROPERTIES: 'setFieldCustomProperties',
  SET_FIELD_GROUPS: 'setFieldGroups',
  SET_INACTIVE_FILTER_VAL: 'setInactiveFilterVal'
}